import { Button, Icon, message, Upload } from 'antd';
import { UploadProps } from 'antd/lib/upload';
import * as React from 'react';
import { Dispatch } from 'redux';
import APIS from 'src/constants/ApiConfig';
import { EnumCustomControl, EnumMedicineCategory } from 'src/constants/enum';
import { IAgentInfo } from 'src/entity/AgentEntity';
import { IDrugStoreInfo } from 'src/entity/DrugStoreEntity';
import { IMallPharmacyDetail } from 'src/entity/MallEntity';
import { getAccessToken } from 'src/redux/actions/authCreator';
import { fetchMallPharmacyIfNeeded, reloadMallPharmacy } from 'src/redux/actions/mallPharmacyCreator';
import { fetchTaskById } from 'src/redux/actions/taskCreator';
import { ITaskMedicineUpload } from 'src/services/FileService';
import I18N from 'src/services/I18NService';
import { getMallUrl } from 'src/services/MallService';
import PriceChangeService, { IPriceApprove } from 'src/services/PriceChangeService';
import PriceChangeTable from './PriceChangeTable';
import { MallService } from '../../services/MallService';

interface IMallMedicineUploadProps {
  title: string;
  /** 药库 */
  pharmacy: IMallPharmacyDetail;
  /** 控件类型 */
  control: EnumCustomControl;
  /** 用户信息 */
  userInfo: IAgentInfo | IDrugStoreInfo;
  /** 是否是代理商 */
  isAgent: boolean;
  /** 是否开启药品订单对接 */
  isOpenMedicine: boolean;

  dispatch: Dispatch<any>;
}

interface IMallMedicineUploadState {
  /** 改价数据 */
  dataSource: IPriceApprove[] | undefined;
  /** 是否显示Modal */
  showModal: boolean;
  /** 改价数据请求中 */
  loading: boolean;
}

class MallMedicineUploadButton extends React.Component<IMallMedicineUploadProps, IMallMedicineUploadState> {
  constructor(props: IMallMedicineUploadProps) {
    super(props);

    this.state = {
      dataSource: undefined,
      showModal: false,
      loading: false,
    } as IMallMedicineUploadState;
  }

  componentDidMount() { }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  /**
   * 获取导入后需要显示的改价申请数据
   *
   * @memberof MedicinePriceUploadButton
   */
  fetchPriceChangeData = async (adjustmentUUID: string) => {
    this.setState({
      loading: true,
    });
    try {
      const res = await PriceChangeService.getPriceNeedChangeByUUID(adjustmentUUID);
      if (!!res) {
        this.setState({
          dataSource: res,
        });
      }
    } catch (error) {
      if (!!error.response) {
        message.error(JSON.stringify(error.response.data));
      } else {
        message.error(I18N.get('err_save_failure'));
      }
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  /**
   * 代理商药材上传控件Props
   * @memberof FileService
   */
  medicineUploadProps = (): UploadProps => {
    const accessToken = getAccessToken();
    const url = getMallUrl(APIS.mall.medicineImport);
    return {
      name: 'medicine',
      action: url,
      showUploadList: false,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      //   data: {
      //     medicine_group: this.props.pharmacy.uuid,
      //   },
      beforeUpload: (file: any) => {
        this.props.dispatch(reloadMallPharmacy());
        MallService.importMallMedicine(file, this.props.pharmacy.uuid, this.props.isAgent, this.props.isOpenMedicine, this.props.pharmacy.category)
          .then((taskObj: ITaskMedicineUpload) => {
            if (!!taskObj && !!taskObj.message) {
              this.props.dispatch(
                fetchTaskById(taskObj.taskid, async () => {
                  this.setState(
                    {
                      showModal: true,
                    },
                    async () => {
                      this.props.dispatch(fetchMallPharmacyIfNeeded());
                      if (this.props.pharmacy.category === EnumMedicineCategory.中药) {
                        if (!!taskObj.adjustment && !this.props.isAgent) {
                          await this.fetchPriceChangeData(taskObj.adjustment);
                        }
                      }
                    }
                  );
                })
              );
            } else {
              message.success(taskObj.message);
            }
          })
          .catch((error: any) => {
            if (!!error.response) {
              message.error(JSON.stringify(error.response.data));
            } else {
              message.error(I18N.get('err_import_failure'));
            }
          });
        return false;
      },
    };
  };

  showPriceChangeModel = () => {
    this.setState({
      dataSource: undefined,
      showModal: false,
      loading: false,
    });
  };

  importElement = (): JSX.Element => {
    const { title, control } = this.props;
    if (control === EnumCustomControl.A) {
      return <a>{title}</a>;
    } else if (control === EnumCustomControl.BUTTON) {
      return (
        <Button type="default">
          <Icon type="upload" />
          {title}
        </Button>
      );
    }
    return <span>{title}</span>;
  };

  render() {
    const fileProps: UploadProps = this.medicineUploadProps();

    const { showModal, loading, dataSource } = this.state;
    const { category } = this.props.pharmacy;
    return (
      <div>
        <Upload {...fileProps} key="medicine-price-upload">
          {this.importElement()}
        </Upload>

        {showModal && category === EnumMedicineCategory.中药 && (
          <PriceChangeTable
            key="mall-medicine-upload-button-price-change-table"
            edit={false}
            visible={showModal}
            loading={loading}
            cbVisible={this.showPriceChangeModel}
            selectedRowKeys={[]}
            userInfo={this.props.userInfo}
            dataSource={dataSource}
          />
        )}
      </div>
    );
  }
}

export default MallMedicineUploadButton;



// WEBPACK FOOTER //
// ./src/components/common/MallMedicineUploadButton.tsx